import type { ListenerEffectAPI, PayloadAction } from "@reduxjs/toolkit";
import { isAnyOf } from "@reduxjs/toolkit";
import {
  clearServiceState,
  setCurrentService,
} from "../../../../../app/state/storageObjectSlice/slice";
import type { AppDispatch, RootState } from "../../../types";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { StorageScope } from "../../../../api/instances/storageApi/types/service_types";
import { serviceHandlers } from "../handlers/storageHandlers";

export function onLeaveServiceListener() {
  appListenerMiddleware.startListening({
    matcher: isAnyOf(setCurrentService),
    effect: async (action: PayloadAction<StorageScope | null>, listenerApi) => {
      const service = action.payload;
      const prevState = listenerApi.getOriginalState() as RootState;
      const prevService = prevState.storageObjectState.currentService;
      if (!service || !prevService || service === prevService) return;

      if (prevService !== service) {
        listenerApi.dispatch(clearServiceState({ service: prevService }));
      }
      const handler = serviceHandlers[prevService];
      if (handler?.onLeave) {
        await handler.onLeave(
          listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
        );
      }
    },
  });
}
